import React, { useEffect, useState } from 'react';
import { Box, Flex, IconButton, Image, Text } from '@chakra-ui/react';
import { FaArrowLeft, FaArrowUp } from 'react-icons/fa';

const PageLayout = ({
  title,
  subtitle,
  onBack,
  rightSlot,
  children,
  contentMaxW = '1200px',
  accent = '#93C8E6',
  background = '#EEF3F7',
  watermark = '/maconaria.png'
}) => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 240);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box
      minH="100vh"
      bg={background}
      color="#0F1A24"
      position="relative"
      overflow="hidden"
      px={{ base: 4, md: 6 }}
      py={{ base: 6, md: 8 }}
    >
      <Box
        position="absolute"
        top="-140px"
        right="-120px"
        width="320px"
        height="320px"
        bg={`radial-gradient(circle at center, ${accent}55, rgba(255,255,255,0))`}
        filter="blur(0px)"
      />
      <Box
        position="absolute"
        bottom="-180px"
        left="-140px"
        width="360px"
        height="360px"
        bg="radial-gradient(circle at center, rgba(16,24,40,0.18), rgba(238,243,247,0))"
      />
      <Box
        position="absolute"
        inset="0"
        bgImage={`url('${watermark}')`}
        bgRepeat="no-repeat"
        bgPosition="center"
        bgSize="520px"
        opacity={0.06}
        pointerEvents="none"
      />

      <Box position="relative" zIndex={1} maxW={contentMaxW} mx="auto">
        <Flex align="center" justify="space-between" mb={{ base: 4, md: 6 }}>
          {onBack ? (
            <IconButton
            aria-label="Voltar"
            icon={<FaArrowLeft />}
            onClick={onBack}
            bg="white"
            color="#0F1A24"
            variant="solid"
            borderRadius="full"
            boxShadow="0 10px 26px rgba(0,0,0,0.12)"
            _hover={{ bg: 'gray.100' }}
          />
        ) : (
          <Box width="48px" />
        )}

          <Image
            src="/icones/logo.png"
            alt="Logo"
            boxSize={{ base: '82px', md: '92px' }}
            objectFit="contain"
            mx="auto"
            filter="drop-shadow(0 10px 24px rgba(0,0,0,0.35))"
          />

          {rightSlot ? <Box>{rightSlot}</Box> : <Box width="48px" />}
        </Flex>

        {(title || subtitle) && (
          <Box textAlign="center" mb={{ base: 5, md: 6 }} color="#0F1A24">
            {subtitle && (
              <Text fontSize="xs" letterSpacing="0.28em" color="gray.500" textTransform="uppercase" mb={1}>
                {subtitle}
              </Text>
            )}
            {title && (
              <Text fontSize={{ base: '2xl', md: '3xl' }} fontFamily="Marcellus" letterSpacing="0.04em">
                {title}
              </Text>
            )}
          </Box>
        )}

        <Box data-highlight-scope="content">
          {children}
        </Box>
      </Box>

      {showTop && (
        <IconButton
          aria-label="Voltar ao topo"
          icon={<FaArrowUp />}
          onClick={handleScrollTop}
          position="fixed"
          right={{ base: 4, md: 6 }}
          bottom={{ base: 6, md: 8 }}
          bg="white"
          color="#0F1A24"
          borderRadius="full"
          boxShadow="0 14px 30px rgba(15,23,42,0.22)"
          _hover={{ bg: 'gray.100' }}
          zIndex={20}
        />
      )}
    </Box>
  );
};

export default PageLayout;
